export const Config = {
	environment: 'development',
	sentry     : {
		dsn        : 'https://bdd80a6ca15e0776a72317e746024b4e@trace.windware.net/2',
		sample_rate: 1,
	},
}
